import { useState } from 'react';
import { UserData } from '../../../model/UserData';
import { checkExpirationDate } from '../../../utils/dateUtils';

/** Hook para administrar el token de sesión que se utiliza
 * durante el proceso de login. Este token es distinto del
 * token de sesión utilizado en el resto de la aplicación.
 */
export const useLoginToken = () => {
  const [loginData, setLoginData] = useState<UserData | undefined>();
  const token = loginData ? loginData.token : undefined;

  function saveSession(token?: string, expirationDate?: string) {
    setLoginData({
      token: token,
      expirationDate: expirationDate,
    });
  }
  /** Validadación de vencimiento de token de sesión*/
  function checkExpiration(): boolean {
    return checkExpirationDate(loginData?.expirationDate);
  }
  function resetLoginToken() {
    setLoginData(undefined);
  }

  return [token, saveSession, checkExpiration, resetLoginToken] as const;
};
